import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import { IconButton, Close } from '@tds/core-interactive-icon';
import TextButton from '@tds/core-text-button';

import request from '../../../../../utils/request';
import TypeAhead from '../../../../../orderDetails/components/typeAhead';

const AddAssignee = ({ orderData, userRights }) => {
  const { canAssignOrder } = userRights;

  const [assigneeList, setAssigneesList] = useState();
  const [assignedUser, setAssignedUser] = useState();
  const [changeAssignee, setChangeAssignee] = useState(false);
  const [updating, setUpdating] = useState(false);

  const updateAssignee = async value => {
    try {
      setChangeAssignee(false);
      setUpdating(true);
      const userId = _.get(value, '0.id', '');
      const orderId = _.get(orderData, 'id', '');
      const result = await request.put(`/orders/${orderId}`, {
        assignedUserId: userId
      });
      if (result) {
        setUpdating(false);
        setAssignedUser(value[0].label);
      }
    } catch (error) {
      setUpdating(false);
    }
  };

  useEffect(() => {
    const getAssignees = async () => {
      const result = await request.get('/sovAgentAndAdminUsers');
      const user = _.get(orderData, 'orderAssignedTo', '');
      if (result) {
        const transformedResult = _.get(result, 'data', []).map(item => ({
          label: item.name,
          id: item.id
        }));

        if (user) {
          setAssignedUser(`${user.first_name} ${user.last_name}`);
        }
        setAssigneesList(transformedResult);
      }
    };
    getAssignees();
  }, []);

  return (
    <div style={{ padding: '0 0.75rem' }}>
      {updating ? (
        <p>Updating...</p>
      ) : (
        <>
          {changeAssignee ? (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <TypeAhead
                label=""
                placeholder="Select an assingee..."
                options={assigneeList}
                onChange={value => updateAssignee(value)}
              />
              <IconButton
                icon={Close}
                onClick={() => setChangeAssignee(false)}
                a11yText="Close"
              />
            </div>
          ) : (
            <div
              style={{ display: 'flex', alignItems: 'center', height: '100%' }}
            >
              <p style={{ marginRight: '1rem' }}>
                {assignedUser || 'Unassigned'}
              </p>
              {canAssignOrder && (
                <TextButton onClick={() => setChangeAssignee(true)}>
                  Change
                </TextButton>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

AddAssignee.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.shape({})).isRequired,
  userRights: PropTypes.objectOf(PropTypes.object).isRequired
};

export default AddAssignee;
